<template>
  <div class="modal-mask">
    <div class="modal-wrapper" @click.self="closeModal">
      <div class="modal-container" :class="{'p-modal-scroll': canScroll}">
        <div class="modal-content">
          <slot name="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    closeModal() {
      this.$emit("close")
    }
  },
  props: {
    canScroll: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
